export default __webpack_public_path__ + "images/YC.4b64b9b.png";